<app-navbar></app-navbar>
<div class="container-fluid mt-3">
    <router-outlet></router-outlet>
</div>
<app-login></app-login>